import { BackButton } from "@/components/back-button";
import { TenantUserList } from "@/features/tenant-user";

import { AdminTenantUserDetail } from "./components/admin-tenant-user-detail";
import { useAdminTenantUserList } from "./hooks/use-admin-tenant-user-list";

export function AdminTenantUserList() {
  const { user, setUser } = useAdminTenantUserList();

  if (user)
    return (
      <>
        <BackButton back={() => setUser(undefined)} />
        <AdminTenantUserDetail user={user} />
      </>
    );

  return <TenantUserList onUserClick={setUser} />;
}
